import { render, staticRenderFns } from "./UploadFoto.vue?vue&type=template&id=e80785f2&"
import script from "./UploadFoto.vue?vue&type=script&lang=js&"
export * from "./UploadFoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadFoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports